import logoCompact from '@/assets/images/logos/logo_compact.svg'
import logoHorizontal from '@/assets/images/logos/logo_horizontal.svg'
import logoWhite from '@/assets/images/logos/logo_horizontal_white.svg'

export default {
    logo: {
        compact: logoCompact,
        full: logoHorizontal,
        dark: logoWhite
    },
}
